// extracted by mini-css-extract-plugin
module.exports = {"answer-list":"style_answer-list__2-Mr0"};